

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETAPPRAISALYEARBYID= createAsyncThunk(
  "getAppraisalYearById/getAppraisalYearById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAppraisalYearByIdSlice = createSlice({
  name: "getAppraisalYearByIdSlice",
  initialState: {
    getAppraisalYearById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAppraisalYearById: (state) => {
        state.getAppraisalYearById.loading = false
        state.getAppraisalYearById.error = false
        state.getAppraisalYearById.data = []
        state.getAppraisalYearById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETAPPRAISALYEARBYID.fulfilled, (state, action) => {
      state.getAppraisalYearById = {
        ...state.getAppraisalYearById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETAPPRAISALYEARBYID.pending, (state, action) => {
      state.getAppraisalYearById = {
        ...state.getAppraisalYearById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETAPPRAISALYEARBYID.rejected, (state, action) => {
      state.getAppraisalYearById = {
        ...state.getAppraisalYearById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAppraisalYearByIdAction = {
    GETAPPRAISALYEARBYID,
};

export { getAppraisalYearByIdAction };
export default getAppraisalYearByIdSlice.reducer;
export const {setInitialStateOfgetAppraisalYearById} = getAppraisalYearByIdSlice.actions
